import { isTMA, openLink } from "@telegram-apps/sdk-react";

export const categoryToAccusative = (category?: string) => {
  if (!category) {
    return "квартиру";
  }

  if (category.endsWith("а")) {
    return `${category.slice(0, -1)}у`;
  }

  return category;
};

export const isTelegramWebApp = () => {
  return isTMA('simple');
}

export const isTelegramWebView = () => {
  // @ts-ignore
  return !isTMA('simple') && window.TelegramWebviewProxy
}

export const openExternalLink = (url: string) => {
  if (isTMA('simple')) {
    openLink(url);
  } else {
    window.open(url, '_blank');
  }
}
